import { AxiosRequestConfig } from "axios";
import { useEffect, useRef, useState, useCallback } from "react";
import { callApi } from "src/utils/callApi";
import { useApiStates } from "./useApiStates";

const useGet = <R = any>(
  request: AxiosRequestConfig,
  config: { dependency?: any; [key: string]: any } = {}
): { results: R; abort: () => void; status: any } => {
  const [results, setResults, updateMessageStatus, isMountedRef] =
    useApiStates<R>();
  const [status, setStatus] = useState<any>("idle");

  // store latest abort function from callApi
  const abortRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const localAbort = callApi({
      request,
      config: {
        isMountedRef,
        setResults,
        updateMessageStatus,
        setStatus,
        ...config,
      },
    });

    abortRef.current = localAbort;

    return () => {
      abortRef.current?.();
      abortRef.current = null;
    };
  }, [config.dependency, request]);

  const abort = useCallback(() => {
    abortRef.current?.();
  }, []);

  return { results, abort, status };
};

export default useGet;
